import Manager from '@/entities/Manager';

export default class ManagerTransformer {
  static transformOne(item) {
    return new Manager(item);
  }

  static transformList(items) {
    return items.map((e) => ManagerTransformer.transformOne(e));
  }
}
